import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCategoryString', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/category_string/issue_form_category.html'),
        controller: 'IssueFormCategoryStringController',
        controllerAs: 'IssueFormCategoryStringCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            category: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/category_string/issue_form_category.component.ts